import React from 'react';
import c from 'classnames';
import { useTranslation } from 'react-i18next';
import { useHits } from 'react-instantsearch';

import { SearchStats } from '@uncinc/react-searchkit';
import type { SearchStatsProps } from '@uncinc/react-searchkit/dist/components/Stats';

import './style.scss';

const SearchForumStats: React.FC<SearchStatsProps> = (props) => {
  const { className, ...restProps } = props;

  const { items } = useHits();
  const { t } = useTranslation('translation', { keyPrefix: 'components.search_forum.stats' });

  const classes = c('SearchForum__Stats', className);

  // Only show stats if there are hits.
  if (!items || items.length === 0) {
    return null;
  }

  return (
    <SearchStats
      {...restProps}
      className={classes}
      translation={(count) => t('results', { count })}
    />
  );
};

export default SearchForumStats;
